(function (){
    var serviceModelList = {
        init: function () {
            var self = this;
            self.setting();
            self.bindEvents();
            self.setObserver();
        },
        setting: function () {
            var self = this;
            self.isApplication = isApp();
            self.isAndroid = vcui.detect.isAndroid;
            self.isIOS = vcui.detect.isIOS;
            self.isMobileDevice = vcui.detect.isMobileDevice;

            //보유제품 등록/수정 팝업
            self.$mpRegiPop = $('.popup-wrap.mp-regi');
            self.$serviceModelChkPop = $("#popup_new2");            
            self.$closeBtn = self.$serviceModelChkPop.find('.btn-close');

            self.$submitBtn = self.$mpRegiPop.find('.btn-subscribe-submit');
            self.$submitBtn.attr('disabled', true);

            //팝업 닫기 관련 alert창
            self.$alertClosePop = $("#laypop1");
            self.$btnOk = self.$alertClosePop.find(".btn-wrap > button.btn:nth-child(2)");
            self.itemData = null;

            // PDP 레이어팝업 관련 - 구독서비스 1차 오픈용 : S
            // self.$prdListWrap = $('.prd-list-wrap'); //221107 추가              
            // self.$seedLayerPop = $("#pdpPopup1");             
            // self.$a9LayerPop = $("#pdpPopup2"); 
            // self.$a9CloseBtn = self.$a9LayerPop.find('.btn-close');
            // self.$seedCloseBtn = self.$seedLayerPop.find('.btn-close');            
            // self.$seedSlideTabs = document.querySelectorAll('#pdpPopup1 .slide-tabs .tabs li');
            // // PDP 레이어팝업 관련 아코디언 tab 추가
            // self.$seedActTabs = document.querySelectorAll('#pdpPopup1 .acc-tabs .tabs li');                        
                             
            // PDP 레이어팝업 관련 - 구독서비스 1차 오픈용 : E

            // 모델 검색
            self.$modelInput = self.$mpRegiPop.find("input[name='sku']");
            self.$modelCheckOk = self.$modelInput.parents(".type-ico").siblings("p.comp");
            self.$modelNotMatch = self.$modelInput.parents(".type-ico").siblings("p.err-msg.not-match");
            self.$modelEmpty = self.$modelInput.parents(".type-ico").siblings("p.err-msg.empty");

            self.$scrollSelect = document.querySelector('#pdpPopup1');
        },

        setObserver : function(){
            var self = this;
                        
            var validModelObserver = new MutationObserver(function(Mutations) {
                Mutations.forEach(function(Mutation) {
                    var isValidModel = $(Mutation.target).hasClass('on');

                    isValidModel ? self.$submitBtn.attr('disabled', false) : self.$submitBtn.attr('disabled', true);
                });
            });
            validModelObserver.observe( self.$modelCheckOk.get(0), {attributes: true} );
        },

        bindEvents : function () {
            var self = this;
            // 틔운 씨앗키트 패키지 종류 탭 - 구독서비스 1차 오픈용 - tab 이벤트 처리 : S
            // for(var i=0; i<  self.$seedSlideTabs.length; i++) {
            //     self.$seedSlideTabs[i].addEventListener('click', function(e){
            //         e.preventDefault();                    
            //         var tabSibilings = $( ".slide-tabs .tabs li" ).siblings().find("img");
            //         var dataTabName = e.currentTarget.dataset.tabName;
            //         var imgSrc = e.target.src;

            //         if(e.target.localName === "img"){
            //             imgSrc = imgSrc.replace("_on.png", "_off.png");
            //             for(var i=0; i<tabSibilings.length; i++) {
            //                 $( ".slide-tabs .tabs li" ).removeClass("on");
            //                 var tabImgSrc = tabSibilings[i].src;
            //                 var tabCurrentImgSrc = tabImgSrc.replace("_on.png","_off.png");
            //                 tabSibilings[i].setAttribute("src", tabCurrentImgSrc);
            //             }                
                        
            //             if(e.currentTarget.className == "on") {
            //                 e.currentTarget.classList.remove("on");
            //                 imgSrc = imgSrc.replace("_on.png", "_off.png");                                           
            //                 $(this).find('img').attr("src",imgSrc);
            //             } else {
            //                 e.currentTarget.classList.add("on");
            //                 imgSrc = imgSrc.replace("_off.png", "_on.png");
            //                 $(this).find('img').attr("src",imgSrc);
            //             }
            //             $(this).find('img').attr('src',imgSrc);


            //             $('#leafy').hide();
            //             $('#herb').hide();
            //             $('#flower').hide();
                                                                                                        
            //             if(dataTabName == "엽채류") {
            //                 $('#leafy').show();
            //             } else if(dataTabName == "허브류") {
            //                 $('#herb').show();
            //             } else {
            //                 $('#flower').show();
            //             }
            //         }
                
            //     });
            // }            
            // 틔운 씨앗키트 패키지 종류 탭 - 구독서비스 1차 오픈용 - tab 이벤트 처리 : E          
            
            // 틔운 씨앗키트 패키지 종류 아코디언 탭 - 구독서비스 1차 오픈용
            // $('.acc-tabs .result-tabs .accordion-button').on('click', function(e) {
            //     $('.acc-tabs .result-tabs .tabs-scroll-wrap').toggleClass('expanded');
            //     if ($('.acc-tabs .result-tabs .tabs-scroll-wrap').hasClass('expanded')) {
            //         $('.acc-tabs .result-tabs .tabs-scroll-wrap').vcSmoothScroll('toggleEnabled', false);
            //     } else {
            //         $('.acc-tabs .result-tabs .tabs-scroll-wrap').vcSmoothScroll('toggleEnabled', true);
            //     }
    
            //     $('.acc-tabs .result-tabs .tabs-scroll-wrap').vcSmoothScroll('moveFirst');
    
            // });

            // 틔운 씨앗키트 패키지 아코디언 탭 클릭 이벤트 추가(앵커처리) - 구독서비스 1차 오픈용 : S
            // for(var i=0; i<self.$seedActTabs.length; i++) {
            //     self.$seedActTabs[i].addEventListener('click',function(e){
            //         e.preventDefault();
            //         $('.acc-tabs .result-tabs .tabs-scroll-wrap').vcSmoothScroll('toggleEnabled', false);
            //         var dataName = e.target.dataset.name;
            //         var targetLiEl= e.target.parentElement;
            //         var dataNameEl = document.querySelector(dataName);
            //         // var topWidth = $(window).innerWidth();
            //         var topTabHeight = $(window).outerHeight() - $(window).innerHeight();
            //         dataNameEl.scrollIntoView({ behavior:"auto", block: "start", inline: "nearest"});
                    
            //         console.log(dataName.parents);
            //         $('.acc-tabs .tabs li').removeClass('on');
                    
            //         if(targetLiEl.classList.contains('on')) {
            //             targetLiEl.classList.remove('on');
            //         } else {
            //             targetLiEl.classList.add('on');
            //         }
                    
            //     });
            // }
            // 틔운 씨앗키트 패키지 아코디언 탭 클릭 이벤트 추가(앵커처리) - 구독서비스 1차 오픈용 : E
            
            // 정기구독 신청하기 버튼 클릭시,
            $('.prd-list-wrap').on('pop', '.btn-subscribe', function(e, data){
                e.preventDefault();

                if ( $(this).hasClass('inactive') ){
                    return;
                }
                self.$mpRegiPop.data('itemData', data.itemData );
                self.itemData = data;                
                var requestSubScribeUrl = self.$mpRegiPop.data('requestSubscribeUrl');
                
                lgkorUI.requestAjaxData(requestSubScribeUrl, data, function(result) {
                    var hasData = typeof result.data == 'undefined' ? false : true;
                    if (hasData && result.data.alert){
                        var alert = result.data.alert;
                        var obj ={
                            title: alert.title,
                            typeClass: '',
                            cancelBtnName: alert.cancelBtnName,
                            okBtnName: alert.okBtnName,
                            ok: alert.okUrl ? function (){
                                location.href = alert.okUrl;
                            } : function (){},
                            cancel: alert.cancelUrl ? function (){
                                location.href = alert.cancelUrl;
                            } : function (){}
                        };
                        var desc = alert.desc ? alert.desc : null;
                        if(alert.title && alert.desc) {
                            obj.typeClass = 'type2'
                        }
                        lgkorUI.confirm(desc, obj);

                    } else {
                        if (hasData && result.data.okUrl){
                            window.location.href = result.data.okUrl;
                        } else {
                            if(e.target.id != ""){
                                self.$serviceModelChkPop.vcModal();
                            }
                        }
                    }
                    
                },'POST');
            });

            // 모델 적용 버튼
            self.$submitBtn.on('click', function(){
                var insertUrl = self.$mpRegiPop.data('insertUrl');
                var modelCode = self.$mpRegiPop.find('input[name=sku]').val();
                var modelSkuDataObj = self.$mpRegiPop.data('skuDATA');
                var isModelSelected = self.$modelCheckOk.hasClass('on');
                
                if (isModelSelected){
                    self.itemData.modelCode = modelCode;
                } else {                    
                    self.$modelNotMatch.removeClass('on');
                    self.$modelEmpty.addClass('on');
                    self.$modelInput.focus();
                    return;
                }

                var itemData = Object.assign( self.itemData, modelSkuDataObj);

                lgkorUI.requestAjaxData(insertUrl, itemData, function(result) {

                    if(!lgkorUI.stringToBool(result.data.success)){
                        lgkorUI.commonAlertHandler(result.data.alert);
                        return;
                    }

                    window.location.href = result.data.okUrl;
                }, 'POST');
            });

            // 팝업 닫기
            self.$closeBtn.on('click', function(){
                self.$alertClosePop.vcModal();                
            });
            // 팝업 alert창 "네" 버튼 클릭시,
            self.$btnOk.on('click', function(){
                self.$alertClosePop.vcModal('close');
                self.$serviceModelChkPop.vcModal('close');                
                self.reset();
                lgkorUI.setEnableAppScrollBottomMenu(true);
                lgkorUI.showAppBottomMenu(true);
                //lgkorUI.showAppBottomMenu(true);
            });

            
            // PDP 레이어팝업  - 구독서비스 1차 오픈용 - tab 이벤트 처리 : S
            //221117 수정, module-type6(구독서비스용 탭카테고리일경우에만 클릭이벤트 실행) : S
            // self.$prdListWrap.on('click', '.module-type6 .img-wrap a', function(e){
            //     e.preventDefault();
            //     self.checkCategory();
            //     $('#leafy').show();
            // });
            // self.$prdListWrap.on('click', '.module-type6 .txt-wrap a', function(e){
            //     e.preventDefault();
            //     self.checkCategory();
            //     $('#leafy').show();
            // });
            //221117 수정, module-type6(구독서비스용 탭카테고리일경우에만 클릭이벤트 실행) : E
            // PDP 레이어팝업 - 구독서비스 1차 오픈용 - tab 이벤트 처리 : E

            // 팝업 닫기
            // self.$seedCloseBtn.on('click', function(){
            //     $('.acc-tabs .compare-result').css('position', 'relative');
            //     self.$seedLayerPop.vcModal('close');
            // });

            // self.$a9CloseBtn.on('click', function() {
            //     self.$a9LayerPop.vcModal('close');
            // });

            if (!vcui.detect.isMobileDevice) {//221130 모바일 디바이스가 아닌 경우 전화번호링크 안되도록
                $('.consulting-box a').each(function(){
                    $(this).removeAttr('href');
                });
            }
        },    
        reset : function(){
            var self = this;
            self.$modelInput.val('');
            self.$modelCheckOk.removeClass('on');
            self.$modelNotMatch.removeClass('on');
            self.$modelEmpty.removeClass('on');

            $('.mp-regi .ui_selectbox:eq(0)').vcSelectbox('selectedIndex', 0, true);
            
        },
        // 구독서비스 1차 오픈용 - 선택한 카테고리 체크하기 위함 221107 수정 - S
        // 221128 수정 : 카테고리명 -> 카테고리 ID 체크로 변경 - S
        // checkCategory : function () { 
        //     var  self = this;
        //     // PDP 레이어팝업 관련 공통 변수추가
        //     self.$tabsCate = document.querySelectorAll('.cate-scroll-wrap .tabs li');
        //     self.$tabCateId = ''; 
            
        //     for (var i=0; i<self.$tabsCate.length; i++) {
        //         if(self.$tabsCate[i].classList.contains('on')) {
        //             self.$tabCateId = self.$tabsCate[i].firstChild.dataset.cateId;
        //         }
        //     }

        //     //카테고리 ID 체크로 변경 - S (개발/검증&운영 다른 카테고리 사용)
        //     if(self.$tabCateId == "CT50090001") { //청소기
        //         self.$a9LayerPop.vcModal();
        //     } else if(self.$tabCateId == "CT50090002") { //식물생활가전
        //         self.$seedLayerPop.vcModal();
        //     }            
        //     //카테고리 ID 체크로 변경 - E
        // }
        // 221128 수정 : 카테고리명 -> 카테고리 ID 체크로 변경 - E
        // 구독서비스 1차 오픈용 - 선택한 카테고리 체크하기 위함 221107 수정 - E 
    };


    $(document).ready(function() {
        serviceModelList.init();
    });
}());


(function(){
    var searchModel = {
        init: function() {
            var self = this;
                self.setting();
                self.bindEvents();
        },
        setting: function() {
            var self = this;  

            //보유제품 등록하기 팝업
            self.$mpRegiPop = $('.popup-wrap.mp-regi');
            self.$mpRegiStep1 = self.$mpRegiPop.find('div.page-change:eq(0)');
            self.$mpRegiStep2 = self.$mpRegiPop.find('div.page-change:eq(1)');

            self.isAppPopup = self.$mpRegiPop.find("div.page-change[data-id='myregist_app']").length > 0;

            if(self.isAppPopup) {
                var tabFlag = new URL(location.href).searchParams.get('tabFlag')
                self.$mpRegiTip = self.$mpRegiPop.find("div.page-change[data-id='myregist_app']");

                // tabFlag == qr 인경우 탭이동
                if(tabFlag == 'qr') self.$mpRegiPop.find('.ui_tab').vcTab('select', 1);

            } else {
                self.$mpRegiTip = self.$mpRegiPop.find('div.page-change:eq(2)');
            }
            
            self.$codeTab1 =  self.$mpRegiPop.find(".form-wrap.category-select"); // 제품별 부착 위치 - 모델명/제조번호/바코드
            //self.$codeTab1 =  self.$mpRegiTip.find("#codeTab1"); // 제품별 부착 위치 - 모델명/제조번호/바코드
            self.$codeTab2 =  self.$mpRegiTip.find("#codeTab2"); // 제품별 부착 위치 - QR
        },
        bindEvents: function() {
            var self = this;
            // 이미지 확대 클릭 방지
            $('a.btn-img-view').on('click',function(e){
                e.preventDefault();
            }),
            //제품별 부착 위치 - 팝업 닫기 버튼 이벤트
            self.$mpRegiTip.on('click','.btn-close' ,function(e){
                if (self.isAppPopup) { 
                    if(vcui.detect.isIOS){ 
                        var jsonString = JSON.stringify({'command':'closeInAppBrowser'});
                        webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                     }else{
                         android.hideWebview(); 
                     }
                } else {
                    if( self.$mpRegiTip.hasClass('step1') ){
                        setTimeout(function(){
                            self.$mpRegiTip.hide();
                            self.$mpRegiStep1.show();
                            self.$mpRegiStep2.hide();
                        }, 100);
                    } else if( self.$mpRegiTip.hasClass('step2') ){
                        setTimeout(function(){
                            self.$mpRegiTip.hide();
                            self.$mpRegiStep1.hide();
                            self.$mpRegiStep2.show();
                        }, 100);
                    }
                }
            });

            // 제품별 부착 위치 - 모델명/제조번호/바코드 이벤트
            self.$codeTab1.on('change', '.ui_selectbox:eq(0)', function(e){
                var index = this.selectedIndex;
                var selectbox = self.$codeTab1.find('.ui_selectbox:eq(1)');
                if(index == 0) {
                    selectbox.prop('disabled', true);
                } else {
                    selectbox.prop('disabled', false);
                    index--;
                    var barcodeModel = self.barcodeModel[index];
                    var optionTemplate = '<option value="{{modelName}}" data-image-url="{{imageUrl}}" data-image-alt="{{imageAlt}}" data-text="{{text}}">{{modelName}}</option>';

                    selectbox.find('option:not(:eq(0))').remove();
                    var arr = barcodeModel.modelList instanceof Array ? barcodeModel.modelList : [];
                    arr.forEach(function(item, index) {
                        if(!item.imageUrl || !item.imageUrl.length) {
                            item.text = item.imageAlt = "제품 이미지 준비중입니다.";
                            item.imageUrl = "/lg5-common/images/img-nodata.svg";
                        }
                        selectbox.append(vcui.template(optionTemplate, item));
                    });                        
                    selectbox.vcSelectbox('update');
                }
                selectbox.vcSelectbox('selectedIndex', 0, true);
            });

            self.$codeTab1.on('change', '.ui_selectbox:eq(1)', function(e){
                var index = this.selectedIndex;
                var selectbox = self.$codeTab1.find('.ui_selectbox:eq(1)');
                var option = selectbox.find('option').eq(index);

                var imageUrl = option.attr('data-image-url');
                var desc = option.attr('data-text');

                if(desc) {
                    self.$mpRegiPop.find('div.example-result p.bullet-text').html(vcui.string.replaceAll(option.attr('data-text'),"\n","<br>"));
                }
                if(imageUrl) {
                    self.$mpRegiPop.find('div.example-result img').attr({'src':option.attr('data-image-url'),'alt':option.attr('data-image-alt')}).css('opacity',1);
                }
            });


            // 제품별 부착 위치 - QR 이벤트
            /*
            self.$codeTab2.on('change', '.ui_selectbox:eq(0)', function(e){
                var index = this.selectedIndex;
                var optionTemplate = '{{#each item in sub }}<option value="{{item.cate}}">{{item.name}}</option>{{/each}}';
                var selectbox =  self.$codeTab2.find('.ui_selectbox:eq(1)');

                selectbox.find('option:not(:eq(0))').remove();
                selectbox.prop('disabled', index === 0 ? true : false)
                         .append(vcui.template(optionTemplate, { sub : self.qrModel[index].sub })).vcSelectbox('update');
                
                self.$codeTab2.find('div.example-result img').attr('src','/lg5-common/images/img-nodata.svg').css('opacity',0);

            });
            self.$codeTab2.on('change', '.ui_selectbox:eq(1)', function(e){
                var selectbox = $(this);
                var qrimageUrl = selectbox.vcSelectbox('selectedOption').value || '/lg5-common/images/img-nodata.svg';
                self.$codeTab2.find('div.example-result img').attr('src',qrimageUrl).css('opacity',1);
            });
            */

            // BTOCSITE-20414 보유제품관리 속도 개선
            self.$mpRegiPop.one('modalshow', function (e) {
                // 제품별 부착 위치 - 모델명/제조번호/바코드 모델 로드
                self.barcodeModelLoad();

                // 제품별 부착 위치 - QR 모델 로드
                //self.qrModelLoad();
            }).trigger('modalshow'); // BTOCSITE-22024
        },
        // 제품별 부착 위치 - 모델명/제조번호/바코드 모델 로드
        barcodeModelLoad: function(){
            var self = this;

            if(!self.barcodeModel) {
                //var selectBox = self.$codeTab1.find(".ui_selectbox:eq(0)");
                //var ajaxUrl = self.$mpRegiTip.data('barcodeModelUrl');
                var selectBox = self.$mpRegiPop.find('.form-wrap.category-select .ui_selectbox:eq(0)');
                var ajaxUrl = self.$mpRegiPop.data('barcodeModelUrl');
                

                lgkorUI.requestAjaxData(ajaxUrl, null, function(result) {
                    var optionTemplate = '<option value="{{value}}">{{value}}</option>';
                    var data = result.data;
                    self.barcodeModel = data;

                    selectBox.find('option:not(:eq(0))').remove();
                    var arr = data instanceof Array ? data : [];
                    arr.forEach(function(item, index) {
                        item.value = item.categoryName
                        selectBox.append(vcui.template(optionTemplate, {"value":item.categoryName}));
                    });
                    selectBox.vcSelectbox('update');
                });
            }
        },

        // 제품별 부착 위치 - QR 모델 로드
        qrModelLoad: function(){
            var self = this;
            self.qrModel = [
                { 
                    cate:"",name:"카테고리 선택",
                    sub: [
                        { cate:'',  name : '세부 카테고리 선택'},
                    ]
                },
                { 
                    cate:"cate1",name:"에어컨",
                    sub: [
                        { cate:'/lg5-common/images/MYC/qrimg/model-stand-air.jpg',   name : '가정용 스탠드형'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-wall-air.jpg',    name : '벽걸이형'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-windows-air.jpg', name : '창문형'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-move-air.jpg',    name : '이동식'}
                    ]
                },
                { 
                    cate:"cate2",name:"세탁기/스타일러",
                    sub: [
                        { cate:'/lg5-common/images/MYC/qrimg/model-front-washers-qr.jpg', name : '드럼세탁기'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-dryers-qr.jpg',        name : '의류건조기'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-top-washers-qr.jpg',   name : '일반세탁기'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-stylers-qr.jpg',       name : '스타일러'}
                    ]
                },
                { 
                    cate:"cate3",name:"청소기",
                    sub: [
                        { cate:'/lg5-common/images/MYC/qrimg/model-stick-cleaners-qr.jpg', name : '무선(A9)/일반'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-robot-cleaners-qr.jpg', name : '로봇청소기'}
                    ]
                },
                { 
                    cate:"cate4",name:"조리/세척기기",
                    sub: [
                        { cate:'/lg5-common/images/MYC/qrimg/model-electric-range.jpg', name : '전기레인지'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-gas-oven.jpg',       name : '가스오븐'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-lightwave-oven.jpg', name: '광파오븐'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-microwave-oven.jpg', name : '전자레인지'}
                    ]

                },
                { 
                    cate:"cate5",name:"에어케어",
                    sub: [
                        { cate:'/lg5-common/images/MYC/qrimg/model-air-purifiers.jpg', name : '공기청정기'},
                        { cate:'/lg5-common/images/MYC/qrimg/model-humidifier.jpg',    name : '제습기'}
                    ]
                },
                { 
                    cate:"cate6",name:"헬스케어",
                    sub: [
                        { cate:'/lg5-common/images/MYC/qrimg/model-water-purifier.jpg', name : '정수기'}
                    ]
                }
            ]

            var selectBox = self.$codeTab2.find(".ui_selectbox:eq(0)");

            var optionTemplate = '{{#each item in cate}}<option value="{{item.cate}}">{{item.name}}</option>{{/each}}';
            selectBox.empty().append(vcui.template(optionTemplate, { cate : self.qrModel}));
        }

    }

    $(document).ready(function() {
        searchModel.init();
    });
})();




(function (global) {  
    /* S: BTOCSITE-20414 보유제품관리 속도 개선 */
    var linkHost = window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";

    
    // 보유제품 등록,수정
    var subcribeProductRegistration = {
        init: function () {
            var self = this;
            self.setting();
            self.bindEvents();
           
        },
        setting: function () {
            var self = this;
           
            self.$mpRegiPop = $('.popup-wrap.mp-regi');
            self.$myProductinputLayerAutoComplete = self.$mpRegiPop.find(".input-layer");
            self.$myRegistCheckBtn = self.$mpRegiPop.find('.input-wrap .btn-check');

            // 제품 모델명
            self.$modelInput = self.$mpRegiPop.find("input[name='sku']");
            self.$modelCheckOk = self.$modelInput.parents(".type-ico").siblings("p.comp");
            self.$modelNotMatch = self.$modelInput.parents(".type-ico").siblings("p.err-msg.not-match");
            self.$modelEmpty = self.$modelInput.parents(".type-ico").siblings("p.err-msg.empty");
            
            
            self.checkModelSuccess = false;

        },

        //검색어 입력중 검색
        requestSearchAutoComplete: function (value) {
            var self = this;
            var ajaxUrl = self.$mpRegiPop.data("autocompleteUrl");
            var modelName = value.toUpperCase();

            lgkorUI.requestAjaxData(ajaxUrl, { sku: modelName, itemData: self.$mpRegiPop.data('itemData') }, function (result) {
                var data = result.data;

                var arr = data && data.listData instanceof Array ? data.listData : [];
                var $list_ul = self.$myProductinputLayerAutoComplete.find("ul");
                $list_ul.empty();
                if (arr.length > 0) {
                    var autoCompleteItemTemplate = '<li><a href="#{{input}}">{{#raw text}}</a></li>';
                    var replaceText = '<span class="search-word">' + modelName + "</span>";
                    arr.forEach(function (item, index) {
                        $list_ul.append(
                            vcui.template(autoCompleteItemTemplate, {
                                input: item,
                                text: vcui.string.replaceAll(item, modelName, replaceText),
                            })
                        );
                    });

                    self.$myProductinputLayerAutoComplete
                        .find(".no-data")
                        .removeClass("on")
                        .end()
                        .find("ul")
                        .addClass("on")
                        .parents(".input-wrap")
                        .addClass("on");
                } else {
                    self.$myProductinputLayerAutoComplete
                        .find("ul")
                        .removeClass("on")
                        .end()
                        .find(".no-data")
                        .addClass("on")
                        .parents(".input-wrap")
                        .addClass("on");
                }
            });
        },
        requestSku: function (mode) {
            var self = this;
            var ajaxUrl = self.$mpRegiPop.data("skuUrl");
            var modelCode = self.$modelInput.val().toUpperCase();

            if (ajaxUrl) {
                lgkorUI.requestAjaxData(
                    ajaxUrl,
                    { sku: modelCode, itemData : self.$mpRegiPop.data('itemData') },
                    function (result) {
                        var data = result.data;
                        self.checkModelSuccess = lgkorUI.stringToBool(data.success);
                        modelPackageFlag = lgkorUI.stringToBool(data.modelPackageFlag);

                        if (self.checkModelSuccess) {
                            self.$modelCheckOk.addClass("on");
                            self.$modelNotMatch.removeClass("on");
                            self.$modelEmpty.removeClass("on");

                            self.$mpRegiPop.data('skuDATA' , {
                                salesCodeSuffix : data.salesCodeSuffix,
                                rtModelSeq : data.rtModelSeq,
                                scModelSeq : data.scModelSeq,
                                scItemSeq : data.scItemSeq
                            });                            

                            //console.log(data.childModelCode);
                            
                        } else {
                            self.$modelCheckOk.removeClass("on");
                            self.$modelNotMatch.addClass("on");                           
                            self.$modelEmpty.removeClass("on");                            

                            //self.emailConfirm(self.$modelInput);
                        }
                    },
                    "GET",
                    "json",
                    true
                );
            }
        },

        bindEvents: function () {
            var self = this;

            //모델명 입력 체크
            self.$modelInput.on("input", function (e) {
                self.checkModelSuccess = false;
                self.$modelCheckOk.removeClass("on");                

                if (e.target.value.length > 20) {
                    e.target.value = e.target.value.slice(0, 20);
                }

                clearTimeout(self.searchTimer);

                var searchVal = e.target.value;                
                if (searchVal.length < 3) {
                    self.$myProductinputLayerAutoComplete.parents(".input-wrap").removeClass("on");
                } else {
                    self.searchTimer = setTimeout(function () {
                        self.requestSearchAutoComplete(searchVal);
                    }, 300);
                }
            });

            self.$modelInput.on("focusout", function (e) {
                e.preventDefault();
                setTimeout(function () {
                    self.$myProductinputLayerAutoComplete.parents(".input-wrap").removeClass("on");
                }, 300);
            });

            //보유제품 등록하기 팝업 : 모델명 자동완성 클릭
            self.$myProductinputLayerAutoComplete.on("click", "a", function (e) {
                e.preventDefault();
                self.checkModelSuccess = false;                

                var modelName = $(this).attr("href").replace("#", "");
                if (modelName && modelName.length > 0) {
                    self.$modelInput.val(modelName.toUpperCase());
                    self.$myRegistCheckBtn.trigger("click");
                }
            });

            //보유제품 등록하기 팝업 : 제품 모델 확인 버튼
            self.$myRegistCheckBtn.on("click", function (e) {
                self.$modelInput.val(self.$modelInput.val().toUpperCase());
                self.checkModelSuccess = false;                

                if (self.$modelInput.val().length > 0) {
                    self.requestSku();
                } else {
                    self.$modelInput.focus();
                    self.$modelCheckOk.removeClass("on");
                    self.$modelNotMatch.removeClass("on");                           
                    self.$modelEmpty.addClass("on");
                }
                return false;
            });
            
        }
    };
   


    $(document).ready(function() {
        // 보유 제품 등록,수정
        subcribeProductRegistration.init();
      
    });
})(window);
